import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { TagPicker } from 'rsuite';
import { useActiveSubtenants } from '../../hooks/useActiveSubtenants';
import { setTenantIds } from '../../stores/slices/preferences';
import { cn } from '../../util';

interface ClinicSelectInputProps {
  onChange?: (tenantIds: string[]) => void;
  defaultValue?: string[];
  placeholder?: string;
  className?: string;
  testId?: string;
}

export function ClinicSelectInput({ onChange, defaultValue, placeholder, className, testId }: ClinicSelectInputProps) {
  const activeSubtenants = useActiveSubtenants();
  const dispatch = useDispatch();

  const clinics = useMemo(
    () => activeSubtenants?.map(({ name, label }) => ({ value: name, label })) ?? [],
    [activeSubtenants]
  );

  const onClinicSelection = useCallback(
    (tenantIds: string[]) => {
      dispatch(setTenantIds(tenantIds?.length ? tenantIds : undefined));
    },
    [dispatch]
  );

  if (clinics.length <= 1) {
    return;
  }

  return (
    <TagPicker
      data={clinics}
      defaultValue={defaultValue}
      onChange={onChange ?? onClinicSelection}
      placeholder={placeholder ?? 'Viewing all clinics'}
      size="lg"
      searchable={false}
      className={cn('w-[300px]', className)}
      menuStyle={{ overflow: 'auto' }}
      data-testid={testId ?? 'clinics-input'}
    />
  );
}
